import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { ArrowLeft, ChevronRight } from 'lucide-react';
import { getIcon } from '../lib/icons';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const CategoryDetailPage = () => {
  const { categoryId } = useParams();
  const navigate = useNavigate();
  const [cat, setCat] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API_URL}/api/categories`)
      .then(r => r.json())
      .then(data => {
        const found = (Array.isArray(data) ? data : []).find(c => c.id === categoryId);
        setCat(found || null);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [categoryId]);

  if (loading) return <div className="loading-spinner" />;

  if (!cat) {
    return (
      <div className="empty-state">
        <h2>Categorie non trouvee</h2>
        <p>Cette categorie n'existe pas.</p>
      </div>
    );
  }

  const Icon = getIcon(cat.icon);
  const catDomains = cat.domains || [];

  return (
    <div>
      {/* Back Header */}
      <div className="back-header">
        <button className="back-btn" onClick={() => navigate(-1)} data-testid="back-btn">
          <ArrowLeft />
        </button>
        <h1>{cat.name}</h1>
      </div>

      {/* Blue Header */}
      <div className="blue-header" data-testid="category-header">
        <h1>{cat.name}</h1>
        <p>{cat.description}</p>
        <div className="text-count">{catDomains.length} texte{catDomains.length !== 1 ? 's' : ''} disponible{catDomains.length !== 1 ? 's' : ''}</div>
      </div>

      {/* Law Text Cards */}
      {catDomains.length > 0 ? (
        catDomains.map(d => (
          <Link
            key={d.code}
            to={`/explorer/${d.code}`}
            className="law-card"
            data-testid={`law-card-${d.code}`}
            style={{ textDecoration: 'none' }}
          >
            <div className="law-card-top">
              <span className="law-badge">{d.type || 'Code'}</span>
              <span className="law-year">{d.year || ''}</span>
            </div>
            <h3>{d.title}</h3>
            <p className="law-subtitle">{d.subtitle}</p>
            <p className="law-desc">{d.desc}</p>
            <div className="read-more">
              {d.total_articles ? `${d.total_articles} articles · ` : ''}Lire plus <ChevronRight style={{ width: '16px', height: '16px' }} />
            </div>
          </Link>
        ))
      ) : (
        <div className="empty-state">
          <div className="icon-circle lg">
            <Icon />
          </div>
          <h2>Bientot disponible</h2>
          <p>Les textes de cette categorie seront ajoutes prochainement.</p>
        </div>
      )}
    </div>
  );
};

export default CategoryDetailPage;
